export default "__VITE_ASSET__5t2w0swp__"